// ABOUTME: The small numbered count badge worn by the rail's bag/heart chips — and now by the
// ABOUTME: spec sheet's add-to-bag action, so one implementation answers for both surfaces.

import React from 'react';
import { u, uMin, CHIP_BADGE } from './railGeometry';

/**
 * Small numbered badge for a count-bearing control (rail chip, spec-sheet bag action).
 *
 * Sized off `--u` like everything else in the chrome, with real-px floors — see CHIP_BADGE. It used
 * to be fixed at 20px/10px, which held its proportion only at the one unit value it was eyeballed
 * against and grew relatively larger every time the chrome scaled down. Because every length is a
 * `--u` multiple, the same component sizes itself correctly inside the mobile spec sheet, where
 * `--u` is the MOBILE unit rather than the rail's.
 *
 * `aria-hidden`: the count is always carried accessibly by the host control's own label, and a
 * bare number read out between a label and its state is noise.
 *
 * @param {{ count?: number }} props — falsy/zero renders nothing, so an empty bag wears no badge.
 */
function ChipBadge({ count }) {
  if (!count) return null;
  return (
    <span
      aria-hidden="true"
      className="absolute -top-1 -right-1 rounded-full bg-reel-chrome-textPrimary text-reel-chrome-panel font-bold flex items-center justify-center"
      style={{
        minWidth: uMin(CHIP_BADGE.size, CHIP_BADGE.minSize),
        height: uMin(CHIP_BADGE.size, CHIP_BADGE.minSize),
        paddingLeft: u(CHIP_BADGE.padX),
        paddingRight: u(CHIP_BADGE.padX),
        fontSize: uMin(CHIP_BADGE.font, CHIP_BADGE.minFont),
      }}
    >
      {count}
    </span>
  );
}

export default ChipBadge;
